module.exports = __webpack_public_path__ + "img/sbl0004.1a08b8f2.png";